import React, { useEffect, useState } from "react";
import Content from "../../Components/Core/Content";
import FormInput from "../../Components/Core/FormInput";
import { Button } from "@mui/material";
import { CreateConsultation } from "../../Services/ConsultionService";
import Loader from "../../Components/Core/Loader";
import Notification from "../../Components/Core/Notification";

const ManualConsultation = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const clearInput = () => {
    setFirstName("");
    setLastName("");
    setMobileNumber("");
  };

  const validateInput = () => {
    if (!firstName.trim()) {
      setSnackbarSeverity("error");
      setSnackbarMessage("لطفاً نام را وارد کنید");
      setOpenSnackbar(true);
      return false;
    }

    if (!lastName.trim()) {
      setSnackbarSeverity("error");
      setSnackbarMessage("لطفاً نام خانوادگی را وارد کنید");
      setOpenSnackbar(true);
      return false;
    }

    if (!mobileNumber.trim()) {
      setSnackbarSeverity("error");
      setSnackbarMessage("لطفاً شماره موبایل را وارد کنید");
      setOpenSnackbar(true);
      return false;
    }

    // Validate mobile number format (11 digits starting with 09)
    const mobileRegex = /^09\d{9}$/;
    const cleanMobile = mobileNumber.replace(/\s/g, "");

    if (!mobileRegex.test(cleanMobile)) {
      setSnackbarSeverity("error");
      setSnackbarMessage("شماره موبایل باید 11 رقم و با 09 شروع شود");
      setOpenSnackbar(true);
      return false;
    }

    return true;
  };

  const submitHandler = async () => {
    if (!validateInput()) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        patientFirstName: firstName.trim(),
        patientLastName: lastName.trim(),
        patientMobileNumber: mobileNumber.trim(),
      };

      await CreateConsultation(payload);

      setSnackbarSeverity("success");
      setSnackbarMessage(
        "مشاوره با موفقیت ثبت شد و به بیمار و پزشک پیامک ارسال گردید"
      );
      setOpenSnackbar(true);
      clearInput();
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage(error.message || "خطا در ثبت مشاوره");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "ثبت مشاوره دستی";
  }, []);

  return (
    <Content>
      {loading ? (
        <Loader />
      ) : (
        <div className="container color-blue mb-5">
          <h2 className="mb-4 row mt-5 highlight-box highlight-secondary fw-bold color-blue">
            <span>ثبت مشاوره دستی</span>
          </h2>

          <div className="row mt-4">
            <div className="col-12 mb-4">
              <div
                className="alert alert-info iran-sans"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(124, 200, 144, 0.1) 0%, rgba(5, 50, 81, 0.05) 100%)",
                  border: "1px solid rgba(124, 200, 144, 0.3)",
                  borderRadius: "12px",
                  padding: "16px",
                }}
              >
                <strong>توجه:</strong> با ثبت این فرم، یک جلسه مشاوره فعال برای
                بیمار ایجاد می‌شود و پیامک تأیید به بیمار و پزشک ارسال خواهد شد.
              </div>
            </div>
          </div>

          <div className="row justify-content-between mt-4">
            <div className="col-md-4 col-11 mb-3">
              <FormInput
                className="form-blue"
                name="نام بیمار"
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
                for="patientFirstName"
                required
                placeHolder="نام بیمار را وارد کنید"
              />
            </div>

            <div className="col-md-4 col-11 mb-3">
              <FormInput
                className="form-blue"
                name="نام خانوادگی بیمار"
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
                for="patientLastName"
                required
                placeHolder="نام خانوادگی بیمار را وارد کنید"
              />
            </div>

            <div className="col-md-4 col-11 mb-3">
              <FormInput
                className="form-blue"
                name="شماره موبایل بیمار"
                onChange={(e) => setMobileNumber(e.target.value)}
                value={mobileNumber}
                for="patientMobileNumber"
                required
                type="tel"
                placeHolder="09123456789"
                dir="ltr"
              />
              <small
                className="text-muted iran-sans"
                style={{ fontSize: "12px" }}
              >
                شماره موبایل باید 11 رقم و با 09 شروع شود
              </small>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12">
              <div
                className="card border-0 shadow-sm"
                style={{
                  background: "#f8f9fa",
                  borderRadius: "12px",
                  padding: "20px",
                }}
              >
                <h6 className="fw-bold color-blue mb-3 iran-sans">
                  اطلاعات مشاوره:
                </h6>
                <ul
                  className="iran-sans"
                  style={{ fontSize: "14px", lineHeight: "2" }}
                >
                  <li>جلسه مشاوره بلافاصله فعال می‌شود</li>
                  <li>پیامک به بیمار و پزشک ارسال خواهد شد</li>
                  <li>در صورت وجود جلسه فعال قبلی، خطا نمایش داده می‌شود</li>
                  <li>
                    اگر بیمار در سیستم ثبت نباشد، حساب کاربری جدید ایجاد می‌شود
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row mt-4 pb-4">
            <div className="col-12">
              <Button
                variant="contained"
                className="btn-blue w-auto px-5"
                onClick={submitHandler}
                disabled={loading || !firstName || !lastName || !mobileNumber}
              >
                <span>ثبت مشاوره</span>
              </Button>
            </div>
          </div>
        </div>
      )}

      <Notification
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        setOpenSnackbar={setOpenSnackbar}
      />
    </Content>
  );
};

export default ManualConsultation;
